(function () {
    'use strict';

    angular
        .module('glossaryTermModule', [
        ]);
})();